module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content-container home"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "slide-container"
  }, [_c('v-touch', {
    staticClass: "slides swipe",
    attrs: {
      "tag": "ul"
    },
    on: {
      "swipeleft": _vm.nextSlide,
      "swiperight": _vm.prevSlide
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('li', {
      class: {
        active: slide.active
      },
      on: {
        "click": function($event) {
          _vm.loadLink(slide)
        }
      }
    }, [_c('vue-picture', {
      attrs: {
        "imgset": slide.image,
        "sizes": _vm.fixedSizes,
        "defaultSize": "scale_crop_1024_461"
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "arrow prev icon-triangle-prev",
    on: {
      "click": function($event) {
        _vm.prevSlide()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow next icon-triangle-next",
    on: {
      "click": function($event) {
        _vm.nextSlide()
      }
    }
  }), _vm._v(" "), _c('nav', [_c('ol', {
    staticClass: "horizontal circles plain"
  }, [_vm._l((_vm.slides), function(slide, index) {
    return [_c('li', {
      class: {
        active: slide.active
      },
      on: {
        "click": function($event) {
          _vm.setActive(index)
        }
      }
    }, [_vm._v(_vm._s(slide.index + 1))])]
  })], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9946029e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 50
// module chunks = 0